'use client'
import {
  visuallyHiddenStyle
} from "./chunk-3JHDQ75O.mjs";

// src/visually-hidden.tsx
import { chakra } from "@chakra-ui/system";
var VisuallyHidden = chakra("span", {
  baseStyle: visuallyHiddenStyle
});
VisuallyHidden.displayName = "VisuallyHidden";
var VisuallyHiddenInput = chakra("input", {
  baseStyle: visuallyHiddenStyle
});
VisuallyHiddenInput.displayName = "VisuallyHiddenInput";
var visually_hidden_default = VisuallyHidden;

export {
  VisuallyHidden,
  VisuallyHiddenInput,
  visually_hidden_default
};
//# sourceMappingURL=chunk-KO6Q73AP.mjs.map